<div class="form" *ngIf="ngFormGroup != null">
    <div class="historyPanel mat-small">
        <div *ngIf="folder.createdDate">
            <strong>created</strong> {{ folder.createdDate | date: 'MMM d, YYYY, h:mm:ss a' }}
            <span *ngIf="folder.createdDate && folder.createdByUserName"><br />by {{ folder.createdByUserName }}</span>
        </div>
        <div *ngIf="folder.modifiedDate > folder.createdDate">
            <strong>modified</strong> {{ folder.modifiedDate | date: 'MMM d, YYYY, h:mm:ss a' }}
            <span *ngIf="folder.modifiedByUserName"><br />by {{ folder.modifiedByUserName }}</span>
        </div>
    </div>
    <form (ngSubmit)="onSave()" *ngIf="ngFormGroup" matForm [formGroup]="ngFormGroup">
        <div *ngIf="folder.canBuildFolders" class="control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name" formControlName="name" required maxlength="256">
            </mat-form-field>
        </div>
        <div *ngIf="!folder.canBuildFolders">
            <div class="read-only-label">Name:</div>
            <div class="read-only">
                {{folder.name}}
            </div>
        </div>

        <div *ngIf="folder.canBuildFolders" class="control-wrapper">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-label>Description:</mat-label>
                <textarea matInput formControlName="description"></textarea>
            </mat-form-field>
        </div>

        <div *ngIf="!folder.canBuildFolders">
            <div class="read-only-label">Description</div>
            <div class="read-only">
                {{folder.description}}
            </div>
        </div>

        <div>
            <div class="read-only-label">Form Template Configuration</div>
        </div>
        <div *ngIf="folder.canBuildFolders" class="control-wrapper">
            <mat-form-field>
                <mat-label>Form Template</mat-label>
                <mat-select formControlName="selectedFormTemplateId">
                    <mat-option *ngIf="!InheritsFolderFormTemplate" [value]="0">{{GetNoneOptionText()}}</mat-option>
                    <mat-option *ngFor="let form of Folder.siteForms"
                                title="{{GetOptionText(form)}}"
                                [value]="form.id">
                        {{GetOptionText(form)}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div *ngIf="SelectedFormTemplateId > 0">
                <mat-label>Mandatory/Default?</mat-label>
                <mat-radio-group formControlName="selectedFormTemplateIsMandatory" aria-label="Select an option">
                    <mat-radio-button [value]="true">Mandatory for this Folder</mat-radio-button>
                    <mat-radio-button [value]="false">Default for this Folder</mat-radio-button>
                </mat-radio-group>
            </div>
        </div>

        <ng-container *ngIf="this.ShowFolderWorkflowProperties">
            <div>
                <div class="read-only-label">Current Workflow State: {{folder.currentWorkflowState}}</div>
            </div>

            <div *ngIf="folder.canBuildFolders" class="control-wrapper">
                <mat-form-field>
                    <mat-label>Workflow</mat-label>
                    <mat-select formControlName="workflowId">
                        <mat-option *ngFor="let wf of folder.siteWorkflows"
                                    title="{{wf.name}}"
                                    [value]="wf.id">
                            {{wf.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div *ngIf="folder.canTransition && folder.workflowStateTransitions && folder.workflowStateTransitions.length > 0">
                <div class="control-wrapper">
                    <mat-form-field>
                        <mat-label>Change Workflow State</mat-label>
                        <mat-select (selectionChange)="transitionWorkflow($event.value)">
                            <mat-option *ngFor="let wfs of folder.workflowStateTransitions"
                                        title="{{wfs.name}}"
                                        [value]="wfs">
                                {{wfs.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </ng-container>

        <mat-accordion [@.disabled]="true" *ngIf="UserIsSysAdmin">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Advanced Settings
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="advanced-settings">
                    <div class="folder-label">Hide Buttons on this Folder's Toolbar</div>
                    <mat-checkbox formControlName="hideExportToExcel">Hide Export to Excel Button</mat-checkbox>
                    <mat-checkbox formControlName="hideDownload">Hide Download Site Button</mat-checkbox>
                    <mat-checkbox formControlName="hideUpload">Hide Upload Button</mat-checkbox>
                    <div class="form-label">Hide Buttons on Forms' Toolbar</div>
                    <mat-checkbox formControlName="hidePrintForm">Hide Print Form Button</mat-checkbox>
                </div>
            </mat-expansion-panel>
        </mat-accordion>

        <div *ngIf="folder.canBuildFolders" class="button-wrapper">
            <button mat-raised-button type="submit" color="primary" [disabled]="!(ngFormGroup.valid && ngFormGroup.dirty)">Save</button>
            <button mat-raised-button type="button" (click)="reset()"><span *ngIf="!ngFormGroup.dirty">Cancel</span><span *ngIf="ngFormGroup.dirty">Reset</span></button>
        </div>
    </form>
</div>
